/**
 * This enum represents the available environment variables.
 */
export enum EnvironmentProfile {
  LOCAL // for local development
  , DEVELOPMENT
  , QUAL
  , PRODUCTION
}
